import React from 'react';

import { Button, Card, Image, Icon, Label } from 'semantic-ui-react'

import { ShopCard, ActionType } from '../types'
import wrappingPaper from '../../assets/wrappings/wrapper-green.png'

import './cardStyles.scss'

interface Props {
  card: ShopCard,
  purchaseCard: (effects: string[], index: number) => void,
  currentAction?: ActionType
}

const isJuleSeason = (): boolean => {
  const month = new Date().getMonth();
  return month === 11 || month === 0;
}

export default function ShopCardComponent(props: Props) {
  const onclick = () => {
    let effects = props.card.Effects;
    if (effects === undefined)
      effects = ['none'];
    props.purchaseCard(effects, props.card.Index);
  }

  const color = props.card.Purchased ? props.card.Purchased!.toLocaleLowerCase() : 'melee-yellow';

  const isSecretSanta = props.card.Name === "Loot Box" && isJuleSeason();
  const displayedName = isSecretSanta ? "Secret Santa" : props.card.Name;

  let isDisabled = props.currentAction !== ActionType.Shop;

  const cardStyle = isSecretSanta ? {
    backgroundImage: `url(${wrappingPaper})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  } : {};

  return (
    <Card className={"shop card-body " + color + (isSecretSanta ? " secret-santa-present" : "")} style={cardStyle}>
      <Card.Content>
        {props.card.Image &&
          <Image
            floated='right'
            size='mini'
            src={props.card.Image}
          />}
        <Card.Header className={'card-text'}>{displayedName}</Card.Header>
        <Card.Meta className={'card-text-yellow'}><Icon name='beer' />{props.card.Cost}</Card.Meta>
        <Card.Description className={'card-text'}>
          {props.card.Description}
        </Card.Description>
      </Card.Content>
      <Card.Content extra >
        {!props.card.Purchased ? (
          <Button basic className='melee' onClick={onclick} disabled={isDisabled} >
            Buy
          </Button>
        ) : (
          <Label as='p' style={{ transform: 'rotate(5deg)' }} color={props.card.Purchased!.toLowerCase() === 'red' ? 'red' : 'blue'} tag>
            Sold
          </Label>
        )}
      </Card.Content>
    </Card>
  )
}
